"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueOptions = void 0;
var GaiaScalars_1 = require("../graphql/GaiaScalars");
var QueueOptions = /** @class */ (function () {
    function QueueOptions(host, port, username, password, deviceId, deviceInstanceId, clientThreads, subscribeTimeout) {
        if (deviceId === void 0) { deviceId = GaiaScalars_1.UUID.randomUUID().toString(); }
        if (deviceInstanceId === void 0) { deviceInstanceId = GaiaScalars_1.UUID.randomUUID().toString(); }
        if (clientThreads === void 0) { clientThreads = 1; }
        if (subscribeTimeout === void 0) { subscribeTimeout = 10; }
        this.protocolVersion = 5;
        this.host = host;
        this.port = port;
        this.clientId = deviceInstanceId; // used by the underlying mqtt library
        this.clientThreads = clientThreads;
        this.username = username;
        this.password = password;
        this.subscribeTimeout = subscribeTimeout;
        this.deviceId = deviceId;
        this.deviceInstanceId = deviceInstanceId;
        this.userId = GaiaScalars_1.UUID.randomUUID().toString();
    }
    return QueueOptions;
}());
exports.QueueOptions = QueueOptions;
//# sourceMappingURL=QueueOptions.js.map